import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_7 = {
  title: "Single pane of glass view for all the \nfiber rollout work orders.",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_3211"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_320"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_07_screen.png",
          imageStyle: { position: "absolute", bottom: "140px", right: "103px" },
        },
      ]}
      pageNumber={"ENG_321"}
    />
  ),
};
